import { createRouter, createWebHistory } from 'vue-router';
import routes from 'virtual:generated-pages';
import packageJson from '$root/package.json';

export default createRouter({
    history: createWebHistory(packageJson.basePath),
    routes,
});
